import React from 'react';
import StipulationAgreeRow from 'components/StipulationAgreeRow';
import { StipulationWrapper } from './style';
import {
  PolicyAgreeAllCheckbox,
  PolicyAgreeAllCheckboxIcon,
  PolicyAgreeAllCheckboxLabel,
  PolicyAgreeAllWrapper,
} from 'pages/Login/JoinMemberPage/JoinMemberStep2/style';

const CheckableTypeStipulation = ({
  stipulationList = [],
  setStipulationList,
  onClickViewBtn,
  stipulationSeq = 'stipulationSeq',
}) => {
  // 모두 동의합니다 체크 영역
  const isAllChecked = stipulationList.every(item => item.checked);
  // 전체 동의
  const onChangeAll = event => {
    const { checked } = event.target;
    setStipulationList(
      stipulationList.map(item => {
        return { ...item, checked };
      })
    );
  };
  //동의 약관 개별 체크
  const onChangeCheckBox = event => {
    const { value, checked } = event.target;
    setStipulationList(
      stipulationList.map(item => {
        return Number(item[stipulationSeq]) === Number(value)
          ? { ...item, checked }
          : item;
      })
    );
  };

  return (
    <div>
      <PolicyAgreeAllWrapper>
        <PolicyAgreeAllCheckboxLabel>
          <PolicyAgreeAllCheckbox
            type="checkbox"
            onChange={onChangeAll}
            checked={isAllChecked}
            readOnly
          />
          모두 동의합니다.
          <PolicyAgreeAllCheckboxIcon />
        </PolicyAgreeAllCheckboxLabel>
      </PolicyAgreeAllWrapper>

      <StipulationWrapper>
        {stipulationList?.map((item, index) => (
          <StipulationAgreeRow
            key={`checkable_stipulation_${item[stipulationSeq]}_${index}`}
            item={item}
            index={index}
            onChangeCheckBox={onChangeCheckBox}
            onClickViewBtn={onClickViewBtn}
            stipulationSeq={stipulationSeq}
            lastRequiredIndex={stipulationList
              ?.map(({ required }) => required)
              ?.lastIndexOf(true)}
          />
        ))}
      </StipulationWrapper>
    </div>
  );
};

export default CheckableTypeStipulation;
